import { Box, Dialog, IconButton } from '@mui/material';

import { Icon } from '@/components/atoms/Icon/Icon';

export interface PhotoViewerProps {
  /** Closed while there is no photo to show. */
  url?: string;
  alt: string;
  onClose: () => void;
}

/** PhotoViewer shows a photo full screen. */
export const PhotoViewer = ({ url, alt, onClose }: PhotoViewerProps) => (
  <Dialog
    fullScreen
    open={!!url}
    onClose={onClose}
    aria-label={alt}
    slotProps={{ paper: { sx: { bgcolor: 'custom.neutral.900' } } }}
  >
    <IconButton
      aria-label='Close photo'
      onClick={onClose}
      sx={(theme) => ({
        position: 'absolute',
        top: `calc(env(safe-area-inset-top) + ${theme.spacing(1.5)})`,
        right: theme.spacing(1.5),
        color: 'common.white',
      })}
    >
      <Icon icon='xmark' fontSize={22} />
    </IconButton>
    <Box
      component='img'
      src={url}
      alt={alt}
      sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
    />
  </Dialog>
);

PhotoViewer.displayName = 'PhotoViewer';
export default PhotoViewer;
